import React from 'react';
import './Separator.scss';

const Separator = ({ marginTB }) => (
    <div className="separator-container"></div>
)

export default Separator;